import React from 'react';

import { isLocalDemoMode } from '#src/utils/localDemo';

type LocalDemoContextValue = {
  isLocalDemo: boolean;
};

const LocalDemoContext = React.createContext<LocalDemoContextValue>({
  isLocalDemo: false,
});

export const LocalDemoProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const value = React.useMemo(() => ({ isLocalDemo: isLocalDemoMode() }), []);

  return (
    <LocalDemoContext.Provider value={value}>
      {children}
    </LocalDemoContext.Provider>
  );
};

export const useLocalDemo = (): LocalDemoContextValue =>
  React.useContext(LocalDemoContext);
